import { useState } from "react";
import { Bars3Icon } from "@heroicons/react/24/solid";
import { Dialog } from "@headlessui/react";
import { useParams } from "react-router";
import { blackTextLogo } from "../../../assets/images/logos";

export default function SidebarDrawer({ menuList }) {
  const { '*': section } = useParams();
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => setIsOpen(false);
  const handleOpen = () => setIsOpen(true);

  return (
    <>
      <button onClick={handleOpen} className="hidden max-lg:block">
        <Bars3Icon className="w-5 h-5 hover:text-orange-500" />
      </button>

      <Dialog open={isOpen} onClose={handleClose} className="fixed inset-0 z-50 lg:hidden">
        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

        <div className="fixed inset-y-0 left-0 max-w-xs w-full bg-white shadow-xl">
          <Dialog.Panel className="h-full flex flex-col">
            <div className="p-4 border-b flex justify-between items-center">
              <a href="/" className="text-lg font-semibold">
                <img loading="lazy" src={blackTextLogo} className="h-6 w-auto" alt="logo" />
              </a>
              <button onClick={handleClose} className="text-gray-500 hover:text-black">
                ✕
              </button>
            </div>

            <nav className="flex-1 overflow-y-auto py-4">
              {menuList.map((item, index) => (
                <a key={index} href={"/admin/" + item.active} className={`w-full px-4 py-3 flex items-center space-x-3 hover:bg-gray-100 transition-colors
                    ${section === item.active ? "bg-orange-50 border-l-4 border-orange-500" : ""}`}>
                  {item.icon}
                  <span className="capitalize">{item.title}</span>
                </a>
              ))}
            </nav>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  )
}
